import React from 'react';
import { Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import { AssignEntitiesEnum } from 'Common/FieldEnum';
import { SiteGridContainer } from '../../containers/assignEntities/SiteGridContainer';
import { ItemGridContainer } from '../../containers/assignEntities/ItemGridContainer';

const AssignSitesToItemsWithStorageLocation = props => {
  const {
    allSitesData,
    allItemsData,
    setIsReadOnlyState,
    isReadOnly,
    setSiteGridInstance,
    setItemGridInstance,
    isRightGridFiltered,
    onRightGridFilteredChange,
    rightSideGridReactTableRef,
    isLeftGridFiltered,
    leftSideGridReactTableRef,
    onLeftGridFilteredChange,
    resetGridPage,
    onResetPageOnDataChange,
  } = props;

  return (
    <Grid>
      <Grid.Row
        columns={2}
        style={{
          marginTop: -15,
        }}
      >
        <Grid.Column width={6}>
          <Field
            component={SiteGridContainer}
            name={AssignEntitiesEnum.SiteGridInfo}
            {...{
              dataSource: allSitesData,
              isLeftMultipleSelect: true,
              isStorageLocationPage: true,
              setIsReadOnlyState,
              isReadOnly,
              setSiteGridInstance,
              leftSideGridReactTableRef,
              isLeftGridFiltered,
              onLeftGridFilteredChange,
              resetGridPage,
              onResetPageOnDataChange,
            }}
          />
        </Grid.Column>
        <Grid.Column width={10}>
          <Field
            component={ItemGridContainer}
            name={AssignEntitiesEnum.ItemGridInfo}
            {...{
              dataSource: allItemsData,
              isStorageLocationPage: true,
              setIsReadOnlyState,
              isReadOnly,
              setItemGridInstance,
              isRightGridFiltered,
              onRightGridFilteredChange,
              rightSideGridReactTableRef,
              resetGridPage,
              onResetPageOnDataChange,
            }}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

AssignSitesToItemsWithStorageLocation.propTypes = {
  allItemsData: PropTypes.array.isRequired,
  allSitesData: PropTypes.array.isRequired,
  resetGridPage: PropTypes.object.isRequired,
  setIsReadOnlyState: PropTypes.func,
  onRightGridFilteredChange: PropTypes.func,
  onLeftGridFilteredChange: PropTypes.func,
  onResetPageOnDataChange: PropTypes.func,
  setSiteGridInstance: PropTypes.func,
  setItemGridInstance: PropTypes.func,
  isReadOnly: PropTypes.bool,
  isRightGridFiltered: PropTypes.bool,
  isLeftGridFiltered: PropTypes.bool,
  rightSideGridReactTableRef: PropTypes.object,
  leftSideGridReactTableRef: PropTypes.object,
};

AssignSitesToItemsWithStorageLocation.defaultProps = {
  isReadOnly: true,
  isRightGridFiltered: false,
  isLeftGridFiltered: false,
  rightSideGridReactTableRef: null,
  leftSideGridReactTableRef: null,
  setSiteGridInstance: () => {},
  setItemGridInstance: () => {},
  setIsReadOnlyState: () => {},
  onRightGridFilteredChange: () => {},
  onLeftGridFilteredChange: () => {},
  onResetPageOnDataChange: () => {},
};

export default AssignSitesToItemsWithStorageLocation;



// WEBPACK FOOTER //
// ./src/pages/utilities/assignentities/components/storageLocation/AssignSitesToItemsWithStorageLocation.js